/* @flow */
import * as React from 'react';

const Bedding = props => (
  <svg
    width={113}
    height={93}
    viewBox="0 0 113 93"
    fillRule="evenodd"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#E8EBF7"
      d="M15.981,1.5 L78.989,1.5 C83.755,1.5 87.619,5.364 87.619,10.131 L87.619,82.393 C87.619,87.16 83.755,91.024 78.989,91.024 L15.981,91.024 C11.214,91.024 7.35,87.16 7.35,82.393 L7.35,10.131 C7.35,5.364 11.214,1.5 15.981,1.5 Z"
    />
    <path
      stroke="#3A427C"
      strokeWidth={3}
      d="M15.981,1.5 L78.989,1.5 C83.755,1.5 87.619,5.364 87.619,10.131 L87.619,82.393 C87.619,87.16 83.755,91.024 78.989,91.024 L15.981,91.024 C11.214,91.024 7.35,87.16 7.35,82.393 L7.35,10.131 C7.35,5.364 11.214,1.5 15.981,1.5 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M84.406,81.835 L84.406,10.69 C84.406,7.389 81.731,4.713 78.43,4.713 L16.538,4.713 C13.239,4.713 10.563,7.389 10.563,10.69 L10.563,81.835 C10.563,85.136 13.239,87.812 16.538,87.812 L78.43,87.812 C81.731,87.812 84.406,85.136 84.406,81.835"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#283060"
      d="M46.726,85.227 L46.754,85.5 C46.513,86.093 46.373,86.739 46.373,87.418 C46.373,88.478 46.699,89.464 47.255,90.281 L47.326,90.954 C54.709,91.153 62.028,91.717 69.452,91.82 C77.159,91.927 84.044,90.627 87.655,83.575 C87.779,79.412 88.145,75.238 88.291,71.285 C88.644,61.765 87.781,52.264 87.676,42.748 C77.337,42.102 64.499,42.332 58.713,43.41 C58.616,43.428 58.523,43.38 58.311,43.234 C57.701,42.812 57.11,42.746 56.558,43.035 C56.064,43.294 55.738,43.852 55.738,44.41 C55.738,44.725 55.836,45.03 56.019,45.285 L56.933,46.557 L56.933,66.809 L56.141,67.887 L47.873,67.887 C43.07,67.887 39.162,71.795 39.162,76.6 C39.162,81.014 42.464,84.662 46.726,85.227"
      opacity={0.2}
    />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      points="1.5 21.705 7.35 21.705 7.35 13.064 1.5 13.064"
    />
    <polygon
      stroke="#1C1F34"
      strokeWidth={3}
      points="1.5 21.705 7.35 21.705 7.35 13.064 1.5 13.064"
    />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M24.42,19.599 L23.07,18.249" />
    <path stroke="#1C1F34" strokeWidth={1.5} d="M24.42,19.599 L23.07,18.249" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M24.42,19.877 L23.07,21.227" />
    <path stroke="#1C1F34" strokeWidth={1.5} d="M24.42,19.877 L23.07,21.227" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M24.697,19.877 L26.047,21.227" />
    <path stroke="#1C1F34" strokeWidth={1.5} d="M24.697,19.877 L26.047,21.227" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M24.697,19.599 L26.047,18.249" />
    <path stroke="#1C1F34" strokeWidth={1.5} d="M24.697,19.599 L26.047,18.249" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M47.346,19.599 L45.996,18.249" />
    <path stroke="#1C1F34" strokeWidth={1.5} d="M47.346,19.599 L45.996,18.249" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M47.346,19.877 L45.996,21.227" />
    <path stroke="#1C1F34" strokeWidth={1.5} d="M47.346,19.877 L45.996,21.227" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M47.623,19.877 L48.973,21.227" />
    <path stroke="#1C1F34" strokeWidth={1.5} d="M47.623,19.877 L48.973,21.227" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M47.623,19.599 L48.973,18.249" />
    <path stroke="#1C1F34" strokeWidth={1.5} d="M47.623,19.599 L48.973,18.249" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M70.271,19.599 L68.921,18.249" />
    <path stroke="#1C1F34" strokeWidth={1.5} d="M70.271,19.599 L68.921,18.249" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M70.271,19.877 L68.921,21.227" />
    <path stroke="#1C1F34" strokeWidth={1.5} d="M70.271,19.877 L68.921,21.227" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M70.549,19.877 L71.899,21.227" />
    <path stroke="#1C1F34" strokeWidth={1.5} d="M70.549,19.877 L71.899,21.227" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M70.549,19.599 L71.899,18.249" />
    <path stroke="#1C1F34" strokeWidth={1.5} d="M70.549,19.599 L71.899,18.249" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M24.42,46.123 L23.07,44.773" />
    <path stroke="#1C1F34" strokeWidth={1.5} d="M24.42,46.123 L23.07,44.773" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M24.42,46.401 L23.07,47.751" />
    <path stroke="#1C1F34" strokeWidth={1.5} d="M24.42,46.401 L23.07,47.751" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M24.697,46.401 L26.047,47.751" />
    <path stroke="#1C1F34" strokeWidth={1.5} d="M24.697,46.401 L26.047,47.751" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M24.697,46.123 L26.047,44.773" />
    <path stroke="#1C1F34" strokeWidth={1.5} d="M24.697,46.123 L26.047,44.773" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M47.346,46.123 L45.996,44.773" />
    <path stroke="#1C1F34" strokeWidth={1.5} d="M47.346,46.123 L45.996,44.773" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M47.346,46.401 L45.996,47.751" />
    <path stroke="#1C1F34" strokeWidth={1.5} d="M47.346,46.401 L45.996,47.751" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M47.623,46.401 L48.973,47.751" />
    <path stroke="#1C1F34" strokeWidth={1.5} d="M47.623,46.401 L48.973,47.751" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M47.623,46.123 L48.973,44.773" />
    <path stroke="#1C1F34" strokeWidth={1.5} d="M47.623,46.123 L48.973,44.773" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M70.271,46.123 L68.921,44.773" />
    <path stroke="#3A427C" strokeWidth={3} d="M70.271,46.123 L68.921,44.773" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M70.271,46.401 L68.921,47.751" />
    <path stroke="#3A427C" strokeWidth={3} d="M70.271,46.401 L68.921,47.751" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M70.549,46.401 L71.899,47.751" />
    <path stroke="#3A427C" strokeWidth={3} d="M70.549,46.401 L71.899,47.751" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M70.549,46.123 L71.899,44.773" />
    <path stroke="#3A427C" strokeWidth={3} d="M70.549,46.123 L71.899,44.773" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M24.42,72.647 L23.07,71.297" />
    <path stroke="#1C1F34" strokeWidth={1.5} d="M24.42,72.647 L23.07,71.297" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M24.42,72.925 L23.07,74.275" />
    <path stroke="#1C1F34" strokeWidth={1.5} d="M24.42,72.925 L23.07,74.275" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M24.697,72.925 L26.047,74.275" />
    <path stroke="#1C1F34" strokeWidth={1.5} d="M24.697,72.925 L26.047,74.275" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M24.697,72.647 L26.047,71.297" />
    <path stroke="#1C1F34" strokeWidth={1.5} d="M24.697,72.647 L26.047,71.297" />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M15.981,1.5 L78.989,1.5 C83.755,1.5 87.619,5.364 87.619,10.131 L87.619,82.393 C87.619,87.16 83.755,91.024 78.989,91.024 L15.981,91.024 C11.214,91.024 7.35,87.16 7.35,82.393 L7.35,10.131 C7.35,5.364 11.214,1.5 15.981,1.5 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M102.487,68.927 C102.487,69.213 101.724,68.266 100.397,68.478 C92.844,69.68 69.423,69.671 62.155,68.449 C60.935,68.244 60.237,69.2 60.237,68.927 L61.433,67.299 L61.433,46.074 L60.237,44.41 C60.237,44.137 60.871,45.092 61.987,44.884 C69.024,43.574 92.86,43.556 100.43,44.83 C101.736,45.05 102.487,44.113 102.487,44.41 L101.292,45.906 L101.292,67.299 L102.487,68.927 Z"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M102.487,68.927 C102.487,69.213 101.724,68.266 100.397,68.478 C92.844,69.68 69.423,69.671 62.155,68.449 C60.935,68.244 60.237,69.2 60.237,68.927 L61.433,67.299 L61.433,46.074 L60.237,44.41 C60.237,44.137 60.871,45.092 61.987,44.884 C69.024,43.574 92.86,43.556 100.43,44.83 C101.736,45.05 102.487,44.113 102.487,44.41 L101.292,45.906 L101.292,67.299 L102.487,68.927 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#9EA1AE"
      d="M109.155,77.027 L110.498,84.364 C110.498,84.364 109.497,91.024 101.477,91.024 L52.743,91.024 L49.577,83.811 C49.577,83.811 43.63,82.638 43.63,76.599 C43.63,70.56 44.532,69.387 53.362,69.387 L105.796,69.387 C105.796,69.387 107.308,70.47 109.29,73.083 L109.155,77.027 Z"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M103.852,76.599 C107.835,76.599 111.064,79.828 111.064,83.811 C111.064,87.795 107.835,91.024 103.852,91.024"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M50.873,69.387 C46.89,69.387 43.661,72.616 43.661,76.599 C43.661,80.583 46.89,83.812 50.873,83.812 L54.479,83.812"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M103.852,83.811 L54.48,83.811 C52.487,83.811 50.873,85.427 50.873,87.418 L50.873,87.418 C50.873,89.409 52.487,91.023 54.48,91.023 L103.852,91.023"
    />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M103.852,76.599 L50.873,76.599" />
    <path stroke="#1C1F34" strokeWidth={3} d="M103.852,76.599 L50.873,76.599" />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M50.873,69.387 L103.851,69.387 C103.851,69.387 103.964,69.379 104.166,69.375 C108.859,69.285 111.527,74.723 108.607,78.397 L108.607,78.397"
    />
  </svg>
);

export default Bedding;



// WEBPACK FOOTER //
// ./src/assets/images/icons/bedding.js